// * This File Sets sessionStorage For Projectwide Usage

let domain_uuid = sessionStorage.getItem("domain_uuid");
const domain = JSON.parse(sessionStorage.getItem("domain"));
const user = JSON.parse(sessionStorage.getItem("user"));
// const isNewTab = sessionStorage.getItem("is_open_admin");

import ServerProviderService from "@/helpers/apiServices/superAdmin/serviceProvider.service.js";
import DeviceProfileService from "@/helpers/apiServices/superAdmin/deviceProfile.service.js";
import ServerService from "@/helpers/apiServices/superAdmin/server.service.js";
import VoiceMailService from "@/helpers/apiServices/voicemail.service.js";
import RecordingService from "@/helpers/apiServices/recording.service.js";
import ExtensionService from "@/helpers/apiServices/extension.service.js";
import RingGroupService from "@/helpers/apiServices/ringgroup.service.js";
import CallCenterService from "@/helpers/apiServices/callCenter.service";
import CallFlowService from "@/helpers/apiServices/callflow.service.js";
import TimeConService from "@/helpers/apiServices/timeCon.service.js";
import MediaServices from "@/helpers/apiServices/media.service.js";
import IVRService from "@/helpers/apiServices/ivr.service.js";
import { tonesOptions } from "@/helpers/global.variables.js";
import errorHandler from "@/helpers/errorHandler.js";

// This function will call all other functions
export let callAllFuncs = async () => {
  const isNewTab = sessionStorage.getItem("is_open_admin");
  if (!sessionStorage.isSettled) {
    if (!["pbx_reseller"].includes(user.user.user_type)) {
      if (!isNewTab) {
        getServerList();
        setServiceProviders();
        getDeviceList();
        sessionStorage.setItem("isSettled", true);
      } else {
        setExtentions();
        setRingGroup();
        sessionStorage.setItem("isSettled", true);
        setCallFlow();
        setIVR();
        setRecordings();
        setVoicemails();
        setTimeConditions();
        setMOH();
        setCallCenter();
        setOthers();
        getAgentList();
      }
    } else {
      sessionStorage.setItem("isSettled", true);
    }
  }
  return;
};

export let setExtentions = async () => {
  await ExtensionService.getExtensionListByColurm("", domain_uuid)
    .then((response) => {
      let extensions = [];
      if (response.result) {
        response.result.map((item) => {
          extensions.push({
            value: item.extension,
            label: item.extension,
            password: item.password,
            mac: item.device_mac_address,
          });
        });
      }
      sessionStorage.setItem("extensions", JSON.stringify(extensions));
    })
    .catch((error) => {
      errorHandler(error);
    });
  return;
};

export let setRingGroup = async () => {
  await RingGroupService.getRingItem("", domain_uuid)
    .then((response) => {
      let ringGroup = [];
      if (response.result) {
        response.result.map((item) => {
          ringGroup.push({
            value: item.ring_group_extension,
            label: `${item.ring_group_extension}${
              item.ring_group_name ? ` (${item.ring_group_name})` : ""
            } `,
          });
        });
      }
      sessionStorage.setItem("ringGroup", JSON.stringify(ringGroup));
    })
    .catch((error) => {
      errorHandler(error);
    });
  return;
};

export let setCallFlow = async () => {
  await CallFlowService.getCallFlowList("", domain_uuid)
    .then((response) => {
      let callFlow = [];
      if (response.result) {
        response.result.map((item) => {
          callFlow.push({
            value: item.call_flow_extension,
            label: item.call_flow_extension,
          });
        });
      }
      sessionStorage.setItem("callFlow", JSON.stringify(callFlow));
    })
    .catch((error) => {
      errorHandler(error);
    });
  return;
};

export let setIVR = async () => {
  await IVRService.getIVRListByColumn("", domain_uuid)
    .then((response) => {
      let ivrOpt = [];
      if (response.result) {
        response.result.map((item) => {
          ivrOpt.push({
            value: item.ivr_menu_extension,
            label: `${item.ivr_menu_extension} ${
              item.ivr_menu_name ? `(${item.ivr_menu_name})` : ""
            }`,
          });
        });
      }
      sessionStorage.setItem("ivrOpt", JSON.stringify(ivrOpt));
    })
    .catch((error) => {
      errorHandler(error);
    });
  return;
};

export let setRecordings = async () => {
  await RecordingService.getRecordingList(domain_uuid)
    .then((response) => {
      let recordings = [];
      let recDataOptions = [];
      if (response.result) {
        response.result.map((item) => {
          recordings.push({
            id: item.recording_uuid,
            item: item,
            value: item.recording_filename,
            label: item.recording_name,
          });
        });
        response.result.map((item) => {
          recDataOptions.push({
            value: `/efs/recordings/${domain.domain_name}/${item.recording_filename}`,
            label: item.recording_name,
            item,
          });
        });
      }
      sessionStorage.setItem("recDataOptions", JSON.stringify(recDataOptions));
      sessionStorage.setItem("recordings", JSON.stringify(recordings));
    })
    .catch((error) => {
      errorHandler(error);
    });
  return;
};

export let setVoicemails = async () => {
  await VoiceMailService.getVoiceMailList(
    `?voicemail_enabled=true`,
    domain_uuid
  )
    .then((response) => {
      let voicemails = [];
      if (response) {
        response.result.map((item) => {
          if (item.voicemail_enabled == "true") {
            voicemails.push({
              value: item.voicemail_id,
              label: item.voicemail_id,
            });
          }
        });
      }
      sessionStorage.setItem("voicemails", JSON.stringify(voicemails));
    })
    .catch((error) => {
      errorHandler(error);
    });
  return;
};

export let setTimeConditions = async () => {
  await TimeConService.getConList("", domain_uuid)
    .then((response) => {
      let timeconditions = [];
      if (response) {
        response.result.map((item) => {
          if (item.dialplan_enabled == "true") {
            timeconditions.push({
              label: `${item.dialplan_number} ${
                item.dialplan_name ? `(${item.dialplan_name})` : ""
              }`,
              value: item.dialplan_number,
            });
          }
        });
      }
      sessionStorage.setItem("timeconditions", JSON.stringify(timeconditions));
    })
    .catch((error) => {
      errorHandler(error);
    });
  return;
};

export let setCallCenter = async () => {
  await CallCenterService.getCallCenterList()
    .then((response) => {
      let callCenters = [];
      if (response) {
        response.result.map((item) => {
          callCenters.push({
            label: `${item.queue_extension} ${
              item.queue_name ? `(${item.queue_name})` : ""
            }`,
            value: item.queue_extension,
            ...item,
          });
        });
      }
      sessionStorage.setItem("callCenters", JSON.stringify(callCenters));
    })
    .catch((error) => {
      errorHandler(error);
    });
  return;
};

export let getAgentList = async () => {
  await CallCenterService.getAgentList("")
    .then((response) => {
      let agentOptions = [];
      if (response) {
        response.result.map((item) => {
          agentOptions.push({
            label: `${item.agent_name} (${item.agent_id})`,
            value: item.agent_name,
          });
        });
      }
      sessionStorage.setItem("agentOptions", JSON.stringify(agentOptions));
    })
    .catch((error) => {
      errorHandler(error);
    });
  return;
};

export let setTones = async () => {
  let toneoptions = [];
  toneoptions = tonesOptions;
  sessionStorage.setItem("toneoptions", JSON.stringify(toneoptions));
  return;
};

export let setOthers = async () => {
  let otheroptions = [];
  otheroptions = [
    {
      value: "record",
      label: "Record",
    },
    {
      value: "hangup",
      label: "Hangup",
    },
    {
      value: "company_directory",
      label: "Company Directory",
    },
    {
      value: "check_voicemail",
      label: "Check Voicemail",
    },
  ];
  sessionStorage.setItem("otheroptions", JSON.stringify(otheroptions));
  return;
};

export let setMOH = async () => {
  MediaServices.getMohList()
    .then((response) => {
      const mohOptions = [];
      const mohDataOptions = [];
      if (response.status == false) {
        return response;
      }
      response.result.map((item) => {
        mohOptions.push({
          value: item.music_on_hold_name.replaceAll("_", " "),
          label: item.music_on_hold_name,
          item,
        });
      });
      response.result.map((item) => {
        mohDataOptions.push({
          value: `/efs/sounds/music/${domain.domain_name}/${item.music_on_hold_name}/48000/moh_file.wav`,
          label: item.music_on_hold_name,
          item,
        });
      });
      sessionStorage.setItem("mohOptions", JSON.stringify(mohOptions));
      sessionStorage.setItem("mohDataOptions", JSON.stringify(mohDataOptions));
    })
    .catch((error) => {
      errorHandler(error);
    });
  return;
};

export let setServiceProviders = async () => {
  let providerOptions = [{ label: "Service Provider", value: "" }];
  ServerProviderService.getServiceProviderList()
    .then((response) => {
      if (response.status) {
        if (Array.isArray(response.result)) {
          response.result.map((item) => {
            providerOptions.push({
              label: item.provider_code,
              value: item.id,
            });
          });
        }
      }
      sessionStorage.setItem(
        "providerOptions",
        JSON.stringify(providerOptions)
      );
    })
    .catch((error) => {
      errorHandler(error);
    });
  return;
};

export let getServerList = async () => {
  let servers = [{ label: "Select Server", value: "", server_ip: "" }];
  await ServerService.getServerList()
    .then((response) => {
      response.result.map((item) => {
        servers.push({
          label: item.server_name,
          value: item.server_name,
          server_ip: item.server_ip,
        });
      });
      sessionStorage.setItem("servers", JSON.stringify(servers));
    })
    .catch((error) => {
      errorHandler(error);
    });
};

export let getDeviceList = async () => {
  let devicesList = [{ label: "Select Device", value: "" }];
  await DeviceProfileService.getDeviceProfileList()
    .then((response) => {
      response.result.map((item) => {
        devicesList.push({
          label: item.model,
          value: item.model,
        });
      });
      sessionStorage.setItem("devicesList", JSON.stringify(devicesList));
    })
    .catch((error) => {
      errorHandler(error);
    });
};
